<template>
  <div class="newsDetail">
    <van-nav-bar :title="schoolDetail.name"
                 left-text=""
                 left-arrow
                 @click-left="onClickLeft" />
    <div class="detailImg">
      <van-image :src="schoolDetail.thumb" />
      <div class="text">
        <div class="con">
          <p><span>
              <van-icon name="award-o" /> 国际排名:
            </span> {{schoolDetail.rank == 9999 ? '-':schoolDetail.rank}} </p>
          <p><span>
              <van-icon name="award-o" /> 国内排名:
            </span> {{schoolDetail.moerank == 9999 ? '-':schoolDetail.moerank}} </p>
          <p><span>
              <van-icon name="location-o" /> 所在城市:
            </span> {{schoolDetail.province_name}} </p>
          <p><span>
              <van-icon name="good-job-o" /> 优势专业:
            </span> {{schoolDetail.discipline[0]}} </p>
        </div>
      </div>
    </div>
    <van-tabs v-model="active">
      <van-tab title="学校概况">
        <div class="container">
          <div v-html="schoolDetail.school_Introduction"
               class="detail"></div>
        </div>
      </van-tab>
      <van-tab title="专业介绍">
        <div class="major">
          <van-tabs type="card">
            <van-tab title="Undergraduate">
              <div class="cont">
                <van-collapse v-model="activeNames">
                  <van-collapse-item :title="item.program"
                                     :name="index"
                                     v-for="(item,index) in schoolDetail.undergraduate"
                                     :key="index">
                    <div class="desc">
                      <p>
                        <b>DURATION:</b><span> {{item.duration}} </span>
                      </p>
                      <p>
                        <b>INSTRUCTION LANGUAGE:</b><span> {{item.instruction_language}} </span>
                      </p>
                      <p>
                        <b>TUITION FEE(RMB):</b><span> {{item.tuiton_Fee}} </span>
                      </p>
                    </div>
                  </van-collapse-item>
                </van-collapse>
              </div>
            </van-tab>
            <van-tab title="Masters'degree">
              <div class="cont">
                <van-collapse v-model="activeNames">
                  <van-collapse-item :title="item.program"
                                     :name="index"
                                     v-for="(item,index) in schoolDetail.masters_degree"
                                     :key="index">
                    <div class="desc">
                      <p>
                        <b>DURATION:</b><span> {{item.duration}} </span>
                      </p>
                      <p>
                        <b>INSTRUCTION LANGUAGE:</b><span> {{item.instruction_language}} </span>
                      </p>
                      <p>
                        <b>TUITION FEE(RMB):</b><span> {{item.tuiton_Fee}} </span>
                      </p>
                    </div>
                  </van-collapse-item>
                </van-collapse>
              </div>
            </van-tab>
            <van-tab title="Doctoral">
              <div class="cont">
                <van-collapse v-model="activeNames">
                  <van-collapse-item :title="item.program"
                                     :name="index"
                                     v-for="(item,index) in schoolDetail.doctoral"
                                     :key="index">
                    <div class="desc">
                      <p>
                        <b>DURATION:</b><span> {{item.duration}} </span>
                      </p>
                      <p>
                        <b>INSTRUCTION LANGUAGE:</b><span> {{item.instruction_language}} </span>
                      </p>
                      <p>
                        <b>TUITION FEE(RMB):</b><span> {{item.tuiton_Fee}} </span>
                      </p>
                    </div>
                  </van-collapse-item>
                </van-collapse>
              </div>
            </van-tab>
          </van-tabs>
        </div>
      </van-tab>
      <van-tab title="奖学金">
        <div class="container">

          <div v-html="schoolDetail.scholarship"
               class="detail"></div>
        </div>
      </van-tab>
      <van-tab title="校园环境">
        <div class="container">
          <van-row gutter="10">
            <van-col span="12"
                     v-for="(item,index) in schoolDetail.school_environment"
                     :key="index">
              <div class="xyimg">
                <van-image :src="item"
                           width="100%"
                           height="100%"
                           fill="fill"
                           @click="onShowImg(index)" />
              </div>
            </van-col>
          </van-row>
        </div>
      </van-tab>
      <van-tab title="视频"
               v-if="(schoolDetail.video != null) && (schoolDetail.video.length != 0)">
        <div class="container">
          <div class="viedoBox">
            <video id="myVideo"
                   Controls
                   :poster="schoolDetail.thumb"
                   class="video-js">
              <source :src="schoolDetail.video"
                      type="video/mp4">
            </video>
          </div>
        </div>
      </van-tab>
    </van-tabs>
    <div class="botline">
      没有更多了
    </div>
  </div>
</template>

<script>
import axiosApi from "../api/api.js";
import { ImagePreview } from 'vant';
export default {
  name: 'Home',
  components: {
  },
  data () {
    return {
      activeNames: [],
      active: 0,
      schoolDetail: '',
    }
  },
  mounted () {
    axiosApi(
      'university/' + this.$route.params.id, {}, 'get'
    ).then((res) => {
      this.schoolDetail = res.data
    })
  },
  methods: {
    onClickLeft () {
      this.$router.go(-1);
    },
    onShowImg (index) {
      ImagePreview({
        images: this.schoolDetail.school_environment,
        startPosition: index,
      });
    }
  }
}
</script>


<style lang="scss" scoped>
.container {
  padding: 20px;
}
.major {
  padding: 20px 0;
  .cont {
    padding: 20px 0;
    .desc {
      p {
        color: #545454;
        font-size: 24px;
        margin-bottom: 10px;
      }
      b {
      }
    }
  }
}
.xyimg {
  width: 100%;
  height: 200px;
  margin-bottom: 20px;
  border-radius: 15px;
  overflow: hidden;
}
.van-tabs__line {
  background-color: #263e65;
}
.viedoBox {
  video {
    width: 100%;
    height: 400px;
    object-fit: fill;
  }
}

.detailImg {
  position: relative;
  .van-image {
    display: block;
  }
  .text {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column-reverse;
    background-color: rgba($color: #ffffff, $alpha: 0.5);
    // background-color: rgba($color: #000000, $alpha: 0.2);
    .con {
      padding: 20px;
      // background-color: rgba($color: #ffffff, $alpha: 0.5);
      p {
        color: #333;
        font-size: 28px;
        line-height: 2;
        b {
          font-size: 32px;
          color: #f29810;
        }
      }
    }
  }
}
</style>
<style lang="scss">
.van-nav-bar .van-icon,
.van-nav-bar__text {
  color: #263e65;
}
.van-tabs__nav--card .van-tab {
  color: #f29810;
}
.van-tabs__nav--card .van-tab.van-tab--active {
  background-color: #f29810;
}
.van-tabs__nav--card .van-tab {
  border-right: 1px solid #f29810;
}
.van-tabs__nav--card {
  border: 1px solid #f29810;
}
</style>